import { ILoginViewModel } from "@viewModels/LoginViewModel/__types__/ILoginViewModel";
import { IUserRepository } from "@repositories/user/types";
import { UserRepository } from "@repositories/user";
import { RequestStatus } from "@constants/repositories";
import { Statuses } from "@viewModels/statuses";
import { AxiosRequestClient } from "domain/modules";
import { IRootTreeModel } from "domain/models";

export class LoginViewModel implements ILoginViewModel {
  public statuses: Statuses = new Statuses(["saving"]);

  private UserRepository: IUserRepository = new UserRepository(
    new AxiosRequestClient(this.model, {})
  );

  public constructor(private model: IRootTreeModel) {}

  public get getToken(): string | null {
    return this.model.storage.getToken;
  }

  public async authUser(user: {
    username: string;
    password: string;
  }): Promise<void> {
    try {
      this.statuses.setStatus("saving", RequestStatus.Pending);

      const { jwt } = await this.UserRepository.authUser(user);
      this.model.storage.setToken(jwt);

      this.statuses.setStatus("saving", RequestStatus.Success);
    } catch (error) {
      this.statuses.setStatus("saving", RequestStatus.Error);

      return Promise.reject(error);
    }
  }

  public async logout(): Promise<void> {
    this.statuses.setStatus("saving", RequestStatus.Pending);
    this.model.storage.deleteToken();
    this.statuses.setStatus("saving", RequestStatus.Success);
  }

  public beforeDestroy(): void {
    this.UserRepository.beforeDestroy();
  }
}
